export function outcomePresentation({
  mode,
  humanSide,
  result,
  detail,
  opponentName,
}) {
  if (mode !== "computer") {
    return {
      kind: "neutral",
      eyebrow: "The match is complete",
      headline: detail,
      detail: "The board has recorded the final position.",
    };
  }
  if (result === "1/2-1/2") {
    return {
      kind: "draw",
      eyebrow: "Even result",
      headline: `Draw with ${opponentName}`,
      detail,
    };
  }
  const humanWon =
    (humanSide === "w" && result === "1-0") ||
    (humanSide === "b" && result === "0-1");
  return humanWon
    ? {
        kind: "win",
        eyebrow: "You won",
        headline: `You defeated ${opponentName}`,
        detail,
      }
    : {
        kind: "loss",
        eyebrow: "Round complete",
        headline: `${opponentName} takes this one`,
        detail,
      };
}

export function confettiMarkup(count = 28) {
  return `<div class="celebration-layer" aria-hidden="true">${Array.from(
    { length: count },
    (_, index) => {
      const x = (index * 37 + 11) % 100;
      const delay = ((index * 13) % 24) / 10;
      const duration = 2.5 + ((index * 17) % 13) / 10;
      const drift = ((index * 29) % 121) - 60;
      const turn = 240 + ((index * 47) % 520);
      return `<i style="--x:${x}%;--delay:${delay}s;--duration:${duration}s;--drift:${drift}px;--turn:${turn}deg"></i>`;
    },
  ).join("")}</div>`;
}
